<div class="container">

  <form [formGroup]="officesForm">
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="officeId">Select Office:</label>
        <select id="officeId" class="form-control" formControlName="officeId">
          <option *ngFor="let office of offices" [value]="office.id">{{ office.city + ' ' + office.address }}</option>
        </select>
      </div>
    </div>
  </form>

  <div class="zk-data-container">
    <div class="mt-3 mb-3" *ngIf="isDeviceUnavailable">No connection to ZkTeco device</div>
    <div class="mt-3 zk-teco-device-data" *ngIf="!isDeviceUnavailable && users && users.length > 0">
      <div class="user-list mt-3 mb-3">
        <table class="table table-striped table-responsive-lg">
          <thead>
          <tr>
            <th scope="col" class="text-center">#</th>
            <th scope="col" class="text-center">Name</th>
            <th scope="col" class="text-center">Group</th>
            <th scope="col" class="text-center">Badge</th>
            <th scope="col" class="text-center">Card</th>
            <th scope="col" class="text-center">Pin</th>
            <th scope="col" class="text-center">Privilege</th>
            <th scope="col" class="text-center">Start Date</th>
            <th scope="col" class="text-center">End Date</th>
<!--            <th scope="col" class="text-center">Disabled</th>-->
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let user of users">
            <td>{{ user.id }}</td>
            <td>{{ user.name }}</td>
            <td class="text-center">
              <i class="fa fa-users" *ngIf="user.group === ZkUserGroup.NONE" data-toggle="tooltip" title="NONE"></i>
              <i class="fa fa-user-circle" *ngIf="user.group === ZkUserGroup.MAIN_PERSONNEL" data-toggle="tooltip" title="MAIN_PERSONNEL"></i>
            </td>
            <td>{{ user.badgeNumber }}</td>
            <td>{{ user.cardNumber }}</td>
            <td>{{ user.pinCode }}</td>
            <td>{{ user.privilege }}</td>
            <td>{{ user.startDate | date:'dd.MM.yy' }}</td>
            <td>{{ user.endDate | date:'dd.MM.yy' }}</td>
<!--            <td class="text-center">-->
<!--              <div class="form-check form-switch user-disabled-checkbox">-->
<!--                <input class="form-check-input" type="checkbox" disabled [value]="user.disabled">-->
<!--              </div>-->
<!--            </td>-->
            <td class="text-center">
              <button type="button" class="btn btn-light edit-button"
                      (click)="openEditModal(officesForm.controls.officeId.value, user)">
                <i class="fas fa-pencil"></i>
              </button>
            </td>
            <td>
              <button type="button" class="btn btn-danger delete-button"
                      (click)="openDeleteConfirmModal(officesForm.controls.officeId.value, user)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <button type="button" class="btn btn-default add-button"
                (click)="openEditModal(officesForm.controls.officeId.value, null)">
          <i class="fas fa-plus"></i> Add new
        </button>
      </div>
    </div>

    <ng-template #emptyLoadingTemplate></ng-template>
    <ngx-loading
      [show]="loading"
      [config]="{
        primaryColour: primaryColour,
        secondaryColour: secondaryColour,
        tertiaryColour: primaryColour,
        backdropBorderRadius: '3px'
      }"
      [template]="emptyLoadingTemplate"></ngx-loading>
  </div>
</div>
